import { ObjectService } from '@ekt-group/general-purpose-api-interfaces';
import { TableProps } from 'antd';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

import { DATE_FORMAT } from '@/constants';
import { formatAsCurrency } from '@/helpers/number-formatter';

type DataType = Omit<ObjectService, 'relatedServices'>;
type ColumnsType<T> = TableProps<T>['columns'];

export function useServicesTable() {
  const { t } = useTranslation('serviceHistoryPage');

  const activityTypeDictionary: Record<number, string> = {
    1: t('install'),
    2: t('deInstall'),
    3: t('lock'),
    4: t('lockTransport'),
    5: t('roundTransport'),
    6: t('wash'),
    7: t('sale'),
    8: t('bioBag'),
    9: t('bioFilter'),
    10: t('bioFilterRent'),
    11: t('bioFilterChange'),
  };

  const columns: ColumnsType<DataType> = [
    {
      key: 1,
      title: t('date'),
      dataIndex: 'issuedAt',
      render: (value) => <span>{dayjs(value).format(DATE_FORMAT)}</span>,
    },
    {
      key: 2,
      title: t('Type'),
      dataIndex: ['activityType'],
      render: (value) => <span>{value ? activityTypeDictionary[value] : 'N/A'}</span>,
    },
    {
      key: 3,
      title: t('objectAddress'),
      dataIndex: ['objectAddress', 'address'],
    },
    {
      key: 4,
      title: t('contractNumber'),
      dataIndex: ['contract', 'contractNumber'],
    },
    {
      key: 5,
      title: t('wasteType'),
      dataIndex: ['garbage', 'name'],
    },
    {
      key: 6,
      title: t('price', { ns: 'invoicesPage' }),
      dataIndex: 'price',
      render: (price) => <span>{formatAsCurrency(Number(price || 0))}</span>,
    },
    {
      key: 7,
      title: t('containerType'),
      dataIndex: ['itemType', 'name'],
    },
  ];

  return {
    columns,
  };
}
